import React, { FunctionComponent } from "react";

export interface Sticker {
  /** Tilt in degrees, ±2–4. Use one sticker per view at most. */
  rotate?: number;
  className?: string;
}

export const Sticker: FunctionComponent<Sticker> = ({
  rotate = -3,
  className = "",
  children,
}) => (
  <span
    className={`sticker ${className}`}
    style={{ transform: `rotate(${rotate}deg)` }}
  >
    {children}
  </span>
);
